<div class="flex items-center gap-1">
  @if (showThresholdColor()) {
    <gc-floating-popup-chart-threshold-color-action [isLabelHidden]="isLabelsHidden()" />
    <div class="self-center mx-[0.375rem] h-[1.25rem] min-w-[1px] w-[1px] bg-(--p-primary-100)"></div>
  }

  @let isChartFullscreenActive = isChartFullscreen();
  <p-button
    severity="contrast"
    [class.activated]="isChartFullscreenActive"
    class="[&.activated_.p-button]:!bg-(--p-primary-500)
      [&_.svg-icon]:!text-(--p-primary-500)
      [&.activated_.svg-icon]:!text-(--p-surface-0)
      [&.activated_.p-button]:hover:!bg-(--p-primary-300)
      [&.activated_.p-button]:hover:!border-0"
    styleClass="!size-7 rounded !border-0 !p-0
      !text-(--p-primary-500)
      hover:!bg-(--p-neutral-500)
      hover:!border-[1px]
      hover:!border-(--p-primary-100)"
    [text]="true"
    (click)="toggleFullscreen()"
    [pTooltip]="(isChartFullscreenActive ? '@@main-exit-full-screen__text' : '@@main-full-screen__text') | translate"
    tooltipPosition="bottom"
    tooltipStyleClass="text-[0.75rem] !z-app-overlay-0">
    @if (isChartFullscreenActive) {
      <svg-icon src="icons/icon-full-screen-filled.svg" class="svg-icon" name="icon-full-screen-filled"></svg-icon>
    } @else {
      <svg-icon src="icons/icon-full-screen-outline.svg" class="svg-icon" name="icon-full-screen-outline"></svg-icon>
    }
  </p-button>

  @if (!isChartFullscreenActive && detailsBtnAvailable) {
    <p-button
      severity="contrast"
      styleClass="!size-7 !px-0 !py-0
        !text-(--p-primary-500)
        hover:!bg-(--p-neutral-500)
        hover:!border-[1px]
        hover:!border-(--p-primary-100)"
      [text]="true"
      [pTooltip]="'@@floating-popup-histogram-details' | translate"
      tooltipPosition="bottom"
      tooltipStyleClass="text-[0.75rem] !z-app-overlay-0">
      <svg-icon src="icons/icon-details.svg" class="text-(--p-primary-500)" name="icon-details"></svg-icon>
    </p-button>
  }
</div>